import { API_BASE_URL, API_TOKEN } from './config';

export const signUp = async (formData) => {
  const fd = new FormData();
  fd.append('action', "signUp");
  fd.append('API_TOKEN', API_TOKEN);

  fd.append('firstName', formData['firstname']);
  fd.append('lastName', formData['lastname']);
  fd.append('username', formData['username']);
  fd.append('email', formData['email']);
  fd.append('password', formData['password']);
  fd.append('confirmPassword', formData['confirmPassword']);
  fd.append('terms', formData['terms']);
  
  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      body: fd, 
    });
    const data = await response.json();
    alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Sign-up error:', error);
    throw error;
  }
};

export const signIn = async (formData) => {
  const fd = new FormData();
  fd.append('action', "signIn");
  fd.append('API_TOKEN', API_TOKEN);

  fd.append('emailOrUsername', formData['emailOrUsername']);
  fd.append('password', formData['password']);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      body: fd, 
    });
    const data = await response.json();
    alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Sign-in error:', error);
    throw error;
  }
};

export const fetchUserProfiles = async () => {
  const fd = new FormData();
  fd.append('action', "fetchUsers");
  fd.append('API_TOKEN', API_TOKEN);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST', //Does not require authentication, or should it?
      body: fd, // Sends the formData as multipart/form-data
    });
    const data = await response.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error fetching user profiles:', error);
    throw error;
  }
};

export const fetchUserSettings = async () => {
  const fd = new FormData();
  fd.append('action', "fetchUserSettings");
  fd.append('API_TOKEN', API_TOKEN);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      body: fd, 
    });
    const data = await response.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error fetching user profiles:', error);
    throw error;
  }
};

export const saveUserSettings = async (formData) => {
  const fd = new FormData();
  fd.append('action', "saveUserSettings");
  fd.append('API_TOKEN', API_TOKEN);
  fd.append('loginToken', localStorage.ncpc_user_not_so_top_secret_data);
  fd.append('emailOrUsername', localStorage.ncpc_user_top_secret_data);

  fd.append('firstname', formData['firstname']);
  fd.append('lastname', formData['lastname']);
  //fd.append('email', formData['email']);
  fd.append('cfHandle', formData['cfHandle']);
  fd.append('phoneNumber', formData['phoneNumber']);
  fd.append('whatsAppNumber', formData['whatsAppNumber']);
  fd.append('userState', formData['userState']);
  fd.append('userlga', formData['userlga']);
  fd.append('fieldOfStudy', formData['fieldOfStudy']);
  fd.append('yearOfStudy', formData['yearOfStudy']);
  fd.append('institution', formData['institution']);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd, // Sends the formData as multipart/form-data
    });
    const data = await response.json();
    //alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error fetching user profiles:', error);
    throw error;
  }
};

export const signOut = async () => {
  const fd = new FormData();
  fd.append('action', "signOut");
  fd.append('API_TOKEN', API_TOKEN);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd, // Sends the formData as multipart/form-data
    });
    const data = await response.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error fetching user profiles:', error);
    throw error;
  }
};

export const fetchProfileData = async (username) => {
  const fd = new FormData();
  fd.append('action', "fetchProfileData");
  fd.append('API_TOKEN', API_TOKEN);
  fd.append('loginToken', localStorage.ncpc_user_not_so_top_secret_data);
  fd.append('emailOrUsername', localStorage.ncpc_user_top_secret_data);
  fd.append('username', username);
  //console.log(username);

  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd, //JSON.stringify(fd),
    });
    const data = await response.json();
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Error fetching user profiles:', error);
    throw error;
  }
};

export const verify_login = async () => {
  let fd =  new FormData();
  fd.append("action", "isLoggedIn");
  fd.append('API_TOKEN', API_TOKEN);
  //This function verifies user login and returns login cookie details if user is logged in.
  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      credentials: "include",
      //headers: { "Content-Type": "application/json" },
      body: fd, // Sends the formData as multipart/form-data
    });
    const data = await response.json();
    //alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Login verification error:', error);
    throw error;
  }
}

export const resetPassword = async (formData) => {
  const fd = new FormData();
  fd.append('action', "resetPassword");
  fd.append('API_TOKEN', API_TOKEN);

  fd.append('password', formData['password']);
  fd.append('confirmPassword', formData['confirmPassword']);
  fd.append('passwordResetToken', formData['passwordResetToken']);
  fd.append('username', formData['username']);
  
  try {
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      body: fd, 
    });
    const data = await response.json();
    alert(data.message);
    //console.log(data);
    return data;
  } catch (error) {
    console.error('Sign-up error:', error);
    throw error;
  }
};